import { FaSlidersH } from "react-icons/fa";

const PANEL_CLASS = {
  floating:
    "fixed right-4 top-1/2 -translate-y-1/2 w-[340px] max-w-[calc(100vw-24px)] h-[78vh] bg-white border border-gray-200 rounded-2xl shadow-2xl overflow-hidden",
  embedded:
    "fixed right-0 top-2 bottom-2 flex w-[400px] max-w-[calc(100vw-12px)] min-h-0 flex-col overflow-hidden rounded-lg border border-gray-300 bg-gray-50 p-3 shadow-lg",
  message:
    "fixed right-0 top-0 h-full w-[360px] max-w-[calc(100vw-16px)] bg-white shadow-lg overflow-hidden",
};

const INNER_CLASS = {
  floating: "flex h-full flex-col p-6",
  embedded: "flex min-h-0 flex-1 flex-col",
  message: "flex h-full flex-col p-6",
};

export default function EmbeddedFilterPanel({
  isOpen,
  onClose,
  onClear,
  children,
  title = "Filters",
  stackZIndex = 10050,
  /** floating = modal popup; embedded = admin page dock; message = full-height sheet */
  variant = "floating",
  /** clearOnly = Atlas-style footer; legacyDoneClear = RichAudits DONE + CLEAR links */
  footerMode = "clearOnly",
  showBackdrop = true,
  showHeaderIcon = false,
}) {
  if (!isOpen) return null;

  const isEmbeddedVariant = variant === "embedded";

  return (
    <>
      {showBackdrop && (
        <div
          className="fixed inset-0 bg-black/25"
          style={{ zIndex: stackZIndex - 1 }}
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <div
        className={PANEL_CLASS[variant] || PANEL_CLASS.floating}
        style={{ zIndex: stackZIndex }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={INNER_CLASS[variant] || INNER_CLASS.floating}>
          <div
            className={
              isEmbeddedVariant
                ? "mb-3 flex shrink-0 items-center justify-between"
                : "mb-6 flex items-center justify-between"
            }
          >
            <h3
              className={
                isEmbeddedVariant
                  ? "text-lg font-semibold text-gray-900"
                  : "flex items-center gap-2 text-lg font-semibold text-gray-900"
              }
            >
              {showHeaderIcon ? (
                <>
                  <FaSlidersH className="text-sidebar-active" aria-hidden />
                  {title}
                </>
              ) : (
                title
              )}
            </h3>
            <button
              type="button"
              onClick={onClose}
              className={
                isEmbeddedVariant
                  ? "flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-2xl leading-none text-muted-foreground transition hover:bg-gray-200/80 hover:text-red-600"
                  : "text-gray-500 transition-colors hover:text-red-600"
              }
              aria-label="Close filters"
            >
              {isEmbeddedVariant ? "✖" : "×"}
            </button>
          </div>

          <div className="min-h-0 flex-1 space-y-5 overflow-y-auto overflow-x-hidden pr-1">
            {children}
          </div>

          <div
            className={
              isEmbeddedVariant
                ? "mt-2 flex shrink-0 justify-end gap-5 border-t border-gray-300 bg-gray-50 pt-4"
                : "mt-8 flex shrink-0 border-t border-gray-200 pt-6"
            }
          >
            {footerMode === "embeddedButtons" ? (
              <div className="flex w-full justify-end gap-5">
                <button
                  type="button"
                  className="rounded-md bg-[#DC1F00] px-4 py-2 text-sm text-white transition hover:bg-[#b51a00]"
                  onClick={onClose}
                >
                  Done
                </button>
                <button
                  type="button"
                  className="rounded-md border border-gray-400 px-4 py-2 text-sm text-gray-700 transition hover:bg-gray-100"
                  onClick={onClear}
                >
                  Clear
                </button>
              </div>
            ) : footerMode === "legacyDoneClear" ? (
              <div className="flex w-full items-center justify-between">
                <button
                  type="button"
                  onClick={onClose}
                  className="font-semibold text-sidebar-active hover:underline"
                >
                  DONE
                </button>
                <button
                  type="button"
                  onClick={onClear}
                  className="font-semibold text-gray-600 hover:underline"
                >
                  CLEAR
                </button>
              </div>
            ) : (
              <div className="flex w-full gap-2">
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 rounded bg-buttonRed hover:bg-buttonRed-hover text-white px-3 py-1.5 text-xs font-semibold shadow-sm transition-all duration-200 active:scale-[0.98]"
                >
                  Done
                </button>
                <button
                  type="button"
                  onClick={onClear}
                  className="flex-1 rounded border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50 active:scale-[0.98]"
                >
                  Clear all
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
